// extracted by mini-css-extract-plugin
module.exports = {"seo_blocks_wrapper":"styles_seo_blocks_wrapper__3Gz14","seo_blocks_wrapper_gray_bg":"styles_seo_blocks_wrapper_gray_bg__3KpmX"};